import { Directive, Input, Optional, Host, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { DropdownContainerComponent } from '../dropdown-container/dropdown-container.component';

@Directive({
    selector: '[dropdownTitle]',
    standalone: false
})
export class DropdownTitleDirective implements OnInit, OnDestroy {
  @Input('dropdownTitle') title: string;
  isHidden = false;
  constructor(@Optional() @Host() private dropdownContainer: DropdownContainerComponent, private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.dropdownContainer.registerTitle(this);
  }
  ngOnDestroy() {
    this.dropdownContainer.unregisterTitle(this);

  }
  show() {
    this.renderer.removeClass(this.elementRef.nativeElement, 'hide');
    this.renderer.addClass(this.elementRef.nativeElement, 'show');
    this.isHidden = false;
  }
  hide() {
    this.renderer.addClass(this.elementRef.nativeElement, 'hide');
    this.renderer.removeClass(this.elementRef.nativeElement, 'show');
    this.isHidden = true;

  }
}
